import { Story } from '@shared/api/types/story';

import { blockchainSportsExclusiveCampaign1000Usdt } from '@store:web/components/pages/StoryPage/hardcodedStories/blockchainSportsExclusiveCampaign1000Usdt';
import { firstProductionSoquestCampaign } from '@store:web/components/pages/StoryPage/hardcodedStories/firstProductionSoquestCampaign';
import { magicSquareLearnToEarn } from '@store:web/components/pages/StoryPage/hardcodedStories/magicSquareLearnToEarn';
import { magicSquareTravala50DollarGiveaway } from '@store:web/components/pages/StoryPage/hardcodedStories/magicSquareTravala50DollarGiveaway';
import { magicSquareZnsConnectCampaignGuide } from '@store:web/components/pages/StoryPage/hardcodedStories/magicSquareZnsConnectCampaignGuide';
import { magicStoreCommunityWeb3 } from '@store:web/components/pages/StoryPage/hardcodedStories/magicStoreCommunityWeb3';
import { magicStoreCommunityZealyQuest } from '@store:web/components/pages/StoryPage/hardcodedStories/magicStoreCommunityZealyQuest';
import { magicstoreFwdx10000Giveaway } from '@store:web/components/pages/StoryPage/hardcodedStories/magicstoreFwdx10000Giveaway';
import { magicStoreKarmaRewards } from '@store:web/components/pages/StoryPage/hardcodedStories/magicStoreKarmaRewards';
import { magicstoreMdbFinancialsExclusive } from '@store:web/components/pages/StoryPage/hardcodedStories/magicstoreMdbFinancialsExclusive';
import { magicstoreProvidaoExclusive5000Giveaway } from '@store:web/components/pages/StoryPage/hardcodedStories/magicstoreProvidaoExclusive5000Giveaway';
import { magicstoreSpinnia } from '@store:web/components/pages/StoryPage/hardcodedStories/magicstoreSpinnia';
import { magicstoreStormTrade } from '@store:web/components/pages/StoryPage/hardcodedStories/magicstoreStormTrade';
import { magicStoreTokenCashback } from '@store:web/components/pages/StoryPage/hardcodedStories/magicStoreTokenCashback';
import { magicstoreTonpunks } from '@store:web/components/pages/StoryPage/hardcodedStories/magicstoreTonpunks';
import { magicstoreZnsConnect } from '@store:web/components/pages/StoryPage/hardcodedStories/magicstoreZnsConnect';
import { metaApesExclusiveCampaignWin15000Shib10000000Giveaway } from '@store:web/components/pages/StoryPage/hardcodedStories/metaApesExclusiveCampaignWin15000Shib10000000Giveaway';
import { popSocialExclusiveCampaignWin25000Shib5750000Giveaway } from '@store:web/components/pages/StoryPage/hardcodedStories/popSocialExclusiveCampaignWin25000Shib5750000Giveaway';
import { zetalabsBlockchainInteroperability } from '@store:web/components/pages/StoryPage/hardcodedStories/zetalabsBlockchainInteroperability';

import { guideToBuyingWelcomePackageInBitHotelAndEarningRewards } from './guideToBuyingWelcomePackageInBitHotelAndEarningRewards';
import { realityMetaverseExclusiveCampaign2500Matic } from './realityMetaverseExclusiveCampaign2500Matic';
import { roadToTgeQuests } from './roadToTgeQuests';
import { stormTrade } from './stormTrade';
import { zealyLeaderboard } from './zealyLeaderboard';

const hardcodedStories: Record<string, Story> = {
  [firstProductionSoquestCampaign.id]: firstProductionSoquestCampaign,
  [guideToBuyingWelcomePackageInBitHotelAndEarningRewards.id]:
    guideToBuyingWelcomePackageInBitHotelAndEarningRewards,
  [magicSquareLearnToEarn.id]: magicSquareLearnToEarn,
  [magicSquareTravala50DollarGiveaway.id]: magicSquareTravala50DollarGiveaway,
  [magicSquareZnsConnectCampaignGuide.id]: magicSquareZnsConnectCampaignGuide,
  [magicStoreCommunityWeb3.id]: magicStoreCommunityWeb3,
  [magicStoreCommunityZealyQuest.id]: magicStoreCommunityZealyQuest,
  [magicStoreKarmaRewards.id]: magicStoreKarmaRewards,
  [magicStoreTokenCashback.id]: magicStoreTokenCashback,
  [magicstoreFwdx10000Giveaway.id]: magicstoreFwdx10000Giveaway,
  [magicstoreMdbFinancialsExclusive.id]: magicstoreMdbFinancialsExclusive,
  [magicstoreProvidaoExclusive5000Giveaway.id]: magicstoreProvidaoExclusive5000Giveaway,
  [magicstoreSpinnia.id]: magicstoreSpinnia,
  [magicstoreStormTrade.id]: magicstoreStormTrade,
  [magicstoreTonpunks.id]: magicstoreTonpunks,
  [magicstoreZnsConnect.id]: magicstoreZnsConnect,
  [metaApesExclusiveCampaignWin15000Shib10000000Giveaway.id]:
    metaApesExclusiveCampaignWin15000Shib10000000Giveaway,
  [popSocialExclusiveCampaignWin25000Shib5750000Giveaway.id]:
    popSocialExclusiveCampaignWin25000Shib5750000Giveaway,
  [zetalabsBlockchainInteroperability.id]: zetalabsBlockchainInteroperability,
  [blockchainSportsExclusiveCampaign1000Usdt.id]: blockchainSportsExclusiveCampaign1000Usdt,
  [realityMetaverseExclusiveCampaign2500Matic.id]: realityMetaverseExclusiveCampaign2500Matic,
  [roadToTgeQuests.id]: roadToTgeQuests,
  [zealyLeaderboard.id]: zealyLeaderboard,
  [stormTrade.id]: stormTrade,
};

export default hardcodedStories;
